// app/javascript/commission_details_form.js
export function initCommissionDetailsForm(root = document) {
    const addBtn = root.querySelector("[data-commission-details-add]");
    const wrapper = root.querySelector("[data-commission-details-wrapper]");
    const templateEl = root.querySelector("[data-commission-details-template]");
  
    if (!addBtn || !wrapper || !templateEl) return;

    function updateRowPrice(event) {
      if (!event.target.matches('input[name$="[number_of_piece]"], input[name$="[single_price]"]')) return;
      const row = event.target.closest('[data-commission-detail-row]');
      if (!row) return;
      const quantity = row.querySelector('input[name$="[number_of_piece]"]');
      const unitPrice = row.querySelector('input[name$="[single_price]"]');
      const price = row.querySelector('input[name$="[price]"]');
      if (!quantity || !unitPrice || !price) return;
      if (!quantity.value.trim() || !unitPrice.value.trim()) {
        price.value = '0.00';
        return;
      }
      const amount = Number(quantity.value.replace(',', '.')) * Number(unitPrice.value.replace(',', '.'));
      if (Number.isFinite(amount)) price.value = amount.toFixed(2);
    }

    wrapper.addEventListener('input', updateRowPrice);
    wrapper.addEventListener('change', updateRowPrice);
  
    function addRow() {
      const html = templateEl.innerHTML.replaceAll("NEW_RECORD", String(Date.now()));
      wrapper.insertAdjacentHTML("beforeend", html);
    }
  
    function removeRow(rowEl) {
      // se è un record già salvato: abbiamo l'input hidden _destroy => metto 1 e nascondo
      const destroyInput = rowEl.querySelector("[data-commission-detail-destroy]") ||
                           rowEl.querySelector('input[name*="[_destroy]"]');
  
      if (destroyInput) {
        destroyInput.value = "1";
        rowEl.style.display = "none";
        return;
      }
  
      // fallback: se non trovo _destroy, rimuovo proprio dal DOM (nuova riga)
      rowEl.remove();
    }
  
    addBtn.addEventListener("click", addRow);
  
    // delega eventi remove
    wrapper.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-commission-details-remove]");
      if (!btn) return;
  
      const row = btn.closest("[data-commission-detail-row]");
      if (!row) return;
  
      removeRow(row);
    });
  }
